import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <>
        <path
            d="M11.9164 7.33317C11.9164 4.80323 9.66141 2.74994 6.8748 2.74994C4.0882 2.74994 1.83325 4.80323 1.83325 7.33317H3.66654L4.58319 6.41652L5.49983 7.33317H9.16642"
            stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
        <path
            d="M11.9164 6.54486C12.8446 5.85861 13.9703 5.49194 15.1246 5.49988C17.9112 5.49988 20.1662 7.55317 20.1662 10.0831H17.4163L16.4996 9.16646L15.583 10.0831H12.833"
            stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
        <path
            d="M5.39909 8.90062C3.4283 10.8714 3.2908 13.9147 5.07826 15.7113L8.96484 11.8156L9.60649 11.1739L10.2573 10.5231L12.2006 8.57979C10.4131 6.78317 7.36988 6.92983 5.39909 8.90062Z"
            stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
        <path
            d="M10.0831 14.208C10.5415 16.4996 9.92732 18.3329 9.1665 20.1662H12.8331C14.6664 15.1246 12.3748 9.16645 11.9164 7.33316"
            stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
    </>
)

export const PalmIcon: React.FC<IconProps> = ({color, size = 22}) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{size, color, renderIcon}} />
)
